import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Student = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb46d__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb46d__a)">
            <path
              fillRule="evenodd"
              d="M35 13q0 2.098-.772 4.049-.839 2.118-2.45 3.73-1.61 1.61-3.729 2.449Q26.099 24 24 24q-2.098 0-4.049-.772-2.118-.839-3.73-2.45-1.61-1.61-2.449-3.729Q13 15.099 13 13q0-2.098.772-4.049.839-2.118 2.45-3.73 1.61-1.61 3.729-2.449Q21.901 2 24 2q2.098 0 4.049.772 2.118.839 3.73 2.45 1.61 1.61 2.449 3.729Q35 10.901 35 13Zm-4 0q0-2.9-2.05-4.95Q26.9 6 24 6q-2.9 0-4.95 2.05Q17 10.1 17 13q0 2.9 2.05 4.95Q21.1 20 24 20q2.9 0 4.95-2.05Q31 15.9 31 13Zm9.856 29q-.246-1.752-.918-3.615-.982-2.726-2.684-5.207-1.588-2.315-3.347-3.776-.926-.77-1.665-1.127l-6.756 7.501a2 2 0 0 1-3.014-.048q-2.529-2.994-6.587-7.35-1.063.547-2.181 1.49-1.82 1.534-3.309 3.725-1.576 2.32-2.454 4.914-.596 1.76-.814 3.493h33.73Zm4.032 0q-.27-2.427-1.186-4.97-1.157-3.21-3.15-6.115-1.902-2.773-4.089-4.59-2.434-2.023-4.602-2.308a2 2 0 0 0-1.747.645l-6.08 6.749q-2.538-2.903-6.175-6.78a2 2 0 0 0-2.074-.534q-2.339.755-4.66 2.712-2.241 1.89-4.039 4.536-1.882 2.77-2.934 5.879Q3.342 39.62 3.101 42H2a2 2 0 1 0 0 4h44a2 2 0 1 0 0-4h-1.112Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
